export default __webpack_public_path__ + "static/media/brainhealth@2x.8eda6a9c.jpg";